import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EuiTimepickerComponent } from './eui-timepicker.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    exports: [
        EuiTimepickerComponent
    ],
    declarations: [
        EuiTimepickerComponent
    ],
})
export class EuiTimepickerComponentModule {
}
